import { Injectable }             from '@angular/core';
import { Http, Response }         from '@angular/http';
import { ResponseContentType }    from '@angular/http';
import { Observable }             from 'rxjs/Observable';
import { ConfigService }          from '../configuracion/config.service';
import { RequestBaseService }     from '../request-base/request-base.service';
import { JwtHttp, AuthService }   from 'ng2-ui-auth';

import 'rxjs/add/operator/map';

@Injectable()
export class PreguntaService extends RequestBaseService {
  constructor(
    protected http: JwtHttp,
    protected auth: AuthService,
    config: ConfigService
  ) {
    super(http, auth);
    this.ApiUrl = [config.getApiUrl(), 'pregunta'].join('/');
  }

  public getPreguntasPorEncuesta($id_encuesta) {
    return this.http
    .get([this.ApiUrl, 'encuesta', $id_encuesta].join('/'))
    .map(res => res.json());
  }

  public getPreguntasEtiquetas(organizacionId, $etiquetas) {
    return this.http
    .get(`${this.ApiUrl}/etiquetas/${organizacionId}/${$etiquetas}`)
    .map(res => res.json());
  }

  public getPreguntasEtiquetas2(organizacionId, etiquetas) {
    return this.http
    .get(`${this.ApiUrl}/pregunta-etiquetas/${organizacionId}/${etiquetas}`)
    .map(res => res.json());
  }

  public deleteEtiqueta(preguntaId: any, etiquetas: any) {
    return this.http
      .delete(`${this.ApiUrl}/eliminar-pregunta-etiquetas/${preguntaId}/${etiquetas}`)
      .map(res => res.json());
  }


  public getPreguntasQuery(label = '') {
    this.validate();

    return this.http
      .get([
        this.ApiUrl, 'reporte', 'query'].join('/') + label, { responseType: ResponseContentType.Blob });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/pregunta/pregunta.service.ts